import { Modal, Button } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";
import { Tab, Tabs } from "react-bootstrap";
import './AddPhishingCompaign';

const AddPhishingCompaign = ({ fetchPhishingCompaign }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showFileUpload, setShowFileUpload] = useState(false);
    const [selectFile, setSelectFile] = useState(null);
    const [arabicError, setArabicError] = useState("");


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleArabicChange = (e) => {
        const { name, value } = e.target;
        // Allow Arabic letters, Arabic/English numbers, and spaces
        const arabicAndNumbersRegex = /^[\u0600-\u06FF0-9\s]+$/;
    
        if (value === "" || arabicAndNumbersRegex.test(value)) {
          setFormData({ ...formData, [name]: value });
          setArabicError(""); // Clear error
        } else {
          setArabicError(t("Please type in Arabic letters or numbers only."));
        }
      };
    const [formData, setFormData] = useState({
        name_ar: "",
        name_en: "",
        start_date: "",
        end_date: "",
        start_time: "",
        save_submitted_data: false,
        enable_attachment: false,
        attachment: null,
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
    
        const allowedTypes = [
            "application/pdf",
            "image/png",
            "image/jpeg",
            "application/msword", 
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
        ];
    
        if (file && !allowedTypes.includes(file.type)) {
            showToast(t("Only PDF, PNG, JPG, or DOC files are allowed"), "error");
            return;
        }
    
        setFormData((prev) => ({
            ...prev,
            attachment: file,
        }));
        setSelectFile(file);
    };
    

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;

        setFormData((prevData) => {
            let newData = { ...prevData, [name]: type === "checkbox" ? checked : value };

            if (name === "enable_attachment") {
                setShowFileUpload(checked);
                if (!checked) {
                    setSelectFile(null);
                    newData.attachment = null;
                }
            }

            if (name === "end_date" && newData.start_date && new Date(value) <= new Date(newData.start_date)) {
                showToast(t("endDateError"), "error");
                return prevData;
            }

            if (name === "start_date" &&  Date(value) < new Date().setHours(0, 0, 0, 0)) {
                showToast(t("startDateError"), "error");
                return prevData;
            }

            if (name === "end_time" && (!newData.start_time || value <= newData.start_time)) {
                showToast(t("endTimeError"), "error");
                return prevData;
            }

            return newData;
        });
    };
  
    const handleAddPhishingCompaign = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        try {
            const token = localStorage.getItem("userToken");
            const formPayload = new FormData();
    
            formPayload.append("name_ar", formData.name_ar);
            formPayload.append("name_en", formData.name_en);
            formPayload.append("start_date", formData.start_date);
            formPayload.append("end_date", formData.end_date);
            formPayload.append("start_time", formData.start_time);
            formPayload.append("save_submitted_data", formData.save_submitted_data ? "1" : "0");
            formPayload.append("enable_attachment", formData.enable_attachment ? "1" : "0");
    
            if (formData.attachment) {
                formPayload.append("attachment", formData.attachment);
            }
    
            const response = await fetch(api_url + "/phishing-campaigns", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                body: formPayload,
            });
    
            const data = await response.json();
            if (response.ok) {
                showToast(t("phishingCampaignAdded"), "success");
                setFormData({
                    name_ar: "",
                    name_en: "",
                    start_date: "",
                    end_date: "",
                    start_time: "",
                    save_submitted_data: false,
                    enable_attachment: false,
                    attachment: null,
                });
                setSelectFile(null);
                setShowFileUpload(false);
                navigate(-1);
            } else {
                showToast(data.message || t("somethingWentWrong"), "error");
            }
        } catch (error) {
            showToast(t("somethingWentWrong"), "error");
        } finally {
            setLoading(false);
        }
    };
    
    // const handleAddPhishingCompaign = async (e) => {
    // e.preventDefault();
    // setLoading(true);

    // try {
    //     const token = localStorage.getItem("userToken");
    //     const formPayload = new FormData();

    //     // append all fields
    //     formPayload.append("name_ar", formData.name_ar);
    //     formPayload.append("name_en", formData.name_en);
    //     formPayload.append("start_date", formData.start_date);
    //     formPayload.append("end_date", formData.end_date);
    //     formPayload.append("start_time", formData.start_time);
    //     formPayload.append("save_submitted_data", formData.save_submitted_data);
    //     formPayload.append("enable_attachment", formData.enable_attachment);

    //     if (formData.attachment) {
    //         formPayload.append("attachment", formData.attachment);
    //     }

    //     const response = await fetch(api_url + "/phishing-campaigns", {
    //         method: "POST",
    //         headers: {
    //             "Authorization": `Bearer ${token}`,
    //         },
    //         body: formPayload,
    //     });

    //     const data = await response.json();
    //     if (response.ok) {
    //         showToast(t("phishingCampaignAdded"), "success");
    //         handleClose();
    //         setFormData({
    //             name_ar: "",
    //             name_en: "",
    //             start_date: "",
    //             end_date: "",
    //             start_time: "",
    //             save_submitted_data: false,
    //             enable_attachment: false,
    //             attachment: null,
    //         });
    //         setShowFileUpload(false);
    //         setSelectFile(null);
    //         navigate(-1);
    //     } else {
    //         showToast(data.message || t("somethingWentWrong"), "error");
    //     }
    // } catch (error) {
    //     showToast(t("somethingWentWrong"), "error");
    // } finally {
    //     setLoading(false);
    // }
    // };


    return (
        <div className="addEmailContainer" style={{ border: '1px solid #EAEAEA', borderRadius: '10px', padding: '26px 26px', margin: '20px', marginBottom: '100px'}}>

            <div className="d-flex justify-content-between mb-3">
                <div className="pageTitle">{t('AddPhishingCampaign')}</div>
                <Button variant="primary" onClick={() => navigate(-1)}>{t('Back')}</Button>
            </div>

            <Tabs defaultActiveKey="AddPhishingCampaign" className="mb-3">
                <Tab eventKey="AddPhishingCampaign" title={t("AddPhishingCampaign")}>
                    <form onSubmit={handleAddPhishingCompaign} className="addEmailForm">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('Namear')}</label>
                                    <input type="text" name="name_ar" className="form-control" onChange={handleArabicChange} value={formData.name_ar} required />
                                    {arabicError && (
                            <div className="text-danger mt-1" style={{ fontSize: "0.9em" }}>
                                {arabicError}
                            </div>
                            )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('Nameen')}</label>
                                    <input type="text" name="name_en" className="form-control" onChange={handleChange} value={formData.name_en} required />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('StartDate')}</label>
                                    <input type="date" name="start_date" className="form-control" onChange={handleChange} value={formData.start_date} required />
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="mb-3">
                                    <label className="form-label">{t('Starttime')}</label>
                                    <input type="time" name="start_time" className="form-control" onChange={handleChange} value={formData.start_time} required />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                            <div className="mb-3">
                                    <label className="form-label">{t('EndDate')}</label>
                                    <input type="date" name="end_date" className="form-control" onChange={handleChange} value={formData.end_date} required />
                                </div>
                            </div>

                            <div className="col-md-6" style={{ marginTop: '25px' }}>
                                <div className="d-flex align-items-center gap-3">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            name="save_submitted_data"
                                            className="form-check-input"
                                            onChange={(e) => handleChange({
                                                target: { name: "save_submitted_data", value: e.target.checked ? true : false }
                                            })}
                                        />
                                        <label className="form-check-label ms-2">{t('SaveSubmittedData')}</label>
                                    </div>

                                    <div className="row">
                                        <div className="d-flex align-items-center gap-3"style={{ marginTop: '15px' }} >
                                            <div className="form-check mb-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    name="enable_attachment"
                                                    checked={formData.enable_attachment}
                                                    onChange={handleChange}
                                                    id="enable_attachment"
                                                />
                                                <label className="form-check-label" htmlFor="enable_attachment">
                                                    {t("EnableAttachment")}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {showFileUpload && (
                            <div className="mb-3">
                                <label className="form-label">Upload PDF or JPG, PNG, Doc File</label>
                                <input
                                    id="fileInput"
                                    type="file"
                                    className="form-control"
                                    accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                                    onChange={handleFileChange}
                                />
                                {selectFile && (
                                    <p className="mt-2 text-success">Selected File: {selectFile.name}</p>
                                )}
                            </div>
                        )}

                        <div className="text-end mt-5">
                            <button type="submit" className="btn btn-primary w-md-auto custom-button-spacing" disabled={loading}>
                                {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : null}
                                {t('AddPhishingCompaign')}
                            </button>
                        </div>
                    </form>
                </Tab>
            </Tabs>
        </div>
    );
};

export default AddPhishingCompaign;
